import request from '@/utils/request'
export function webIndex() {
    return request({
        url: '/home/homePageNew',
        method: 'get'
    })
}
export function secondPageTop(params) {
    return request({
        url: '/home/secondPageTop',
        method: 'get',
        params: params
    })
}
export function homeIndex() {
    return request({
        url: '/home/homePage',
        method: 'get'
    })
}
// 首页-康养馆
export function apiHomePageKyg(){
    return request({
        url: '/home/homePageKyg',
        method: 'get'
    })
}
// 首页-地域馆
export function apiHomePageDyg(){
    return request({
        url: '/home/homePageDyg',
        method: 'get'
    })
}
// 首页-名企精品
export function apiHomePageMqjp(){
    return request({
        url: '/home/homePageMqjp',
        method: 'get'
    })
}
// 首页-9.9包邮
export function apiHomePageNnby(){
    return request({
        url: '/home/homePageNnby',
        method: 'get'
    })
}
// 首页-搜精品自营
export function apiHomePageSjpzy(){
    return request({
        url: '/home/homePageSjpzy',
        method: 'get'
    })
}
// 首页-每日爆款
export function apiHomePageMrbk(){
    return request({
        url: '/home/homePageMrbk',
        method: 'get'
    })
}
// 首页-拼团嗨购
export function apiHomePagePthg(){
    return request({
        url: '/home/homePagePthg',
        method: 'get'
    })
}
// 首页-限时购
export function apiHomePageXsg(){
    return request({
        url: '/home/homePageXsg',
        method: 'get'
    })
}
// 首页-优惠中心
export function apiHomePageYhzx(){
    return request({
        url: '/home/homePageYhzx',
        method: 'get'
    })
}